import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  AdditionalOptions,
  CoverageLimit,
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseRules, TextValues } from './texas.model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-texas',
  templateUrl: './texas.component.html',
  styleUrls: ['./texas.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class TexasComponent extends PipBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('texas', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('texas', null);
    }
  }
  onSelect(selectionId: string, formControlName: string): void {
    if (selectionId === 'AcceptCoverage_RejectAdditionalPIP_VaryByState' || 
      selectionId === 'AcceptCoverage_AcceptAdditionalPIP_VaryByState' || 
      selectionId === 'AcceptCoverage_VaryByState_VaryByState'
    ) {
      if (formControlName === 'Select_Aggregate_Total_Limits_DropDown') {
        if (
          this.reactiveForm.get('Select_Aggregate_Total_Limits_DropDown').valid
        ) {
          this.reactiveForm
            .get('levelOne_Radio')
            .setValue('Select_LevelOne_Radio');
        }
      }
    }
  }
  

  override dynamicRuleQueryBuilder(): string {
    const s = this.baseRulesService;
    // ShowSelectAndReject
    if (
      s.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.IndividualStateCoverage &&
      (s.additionalOptions === AdditionalOptions.RejectAdditionalPIP ||
        s.additionalOptions === AdditionalOptions.VaryByState ||
        s.additionalOptions === AdditionalOptions.AcceptAdditionalPIP)
    ) {
      return 'ShowSelectAndReject';
    }
    // ShowSelectAggLimit
    if (
      s.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.AcceptCoverage &&
      s.coverageLimit === CoverageLimit.VaryByState &&
      (s.additionalOptions === AdditionalOptions.RejectAdditionalPIP ||
        s.additionalOptions === AdditionalOptions.VaryByState ||
        s.additionalOptions === AdditionalOptions.AcceptAdditionalPIP)
    ) {
      return 'ShowSelectAggLimit';
    }
  }
}
